window.theme = window.theme || {};

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.promotion = this.querySelector(".promotion");
    this.wrapper = this.querySelector(".promotion__wrapper");
    if (!this.promotion || !this.wrapper) return;

    // Get speed from data attribute
    const speedSetting = this.dataset.speed || "1.6";
    // Convert speed setting to animation duration
    const duration = this.getAnimationDuration(speedSetting);
    this.style.setProperty("--scroll-speed", `${duration}s`);

    // Clone the wrapper content
    this.cloneContent();

    // Set up intersection observer
    this.setupObserver();

    // Handle resize events
    this.resizeObserver = new ResizeObserver(() => {
      this.cloneContent();
    });
    this.resizeObserver.observe(this.wrapper);

    // Start checking for smooth looping
    this.checkScroll();
  }

  getAnimationDuration(speed) {
    // Convert speed settings to duration in seconds
    const speedMap = {
      0.5: 40, // Very Slow
      "1.0": 30, // Slow
      1.6: 20, // Normal
      "2.0": 15, // Fast
      "3.0": 10, // Very Fast
    };
    return speedMap[speed] || 20; // Default to normal speed if setting not found
  }

  cloneContent() {
    if (!this.wrapper) return;

    // Remove existing clones
    const existingClones = this.wrapper.querySelectorAll(".clone");
    existingClones.forEach((clone) => clone.remove());

    // Get all original items
    const originalContent = Array.from(this.wrapper.children);

    // Clone all items once
    originalContent.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.classList.add("clone");
      clone.setAttribute("aria-hidden", "true");
      this.wrapper.appendChild(clone);
    });
  }

  checkScroll() {
    if (!this.promotion) return;

    // Reset animation when it completes to ensure smooth infinite loop
    this.promotion.addEventListener("animationend", () => {
      this.promotion.style.animation = "none";
      this.promotion.offsetHeight; // Trigger reflow
      this.promotion.style.animation = null;
    });
  }

  setupObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.promotion.style.animationPlayState = "running";
          } else {
            this.promotion.style.animationPlayState = "paused";
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    observer.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define("scrolling-promotion", ScrollingPromotion);
